import React, {Component} from 'react';
import {SortableContainer, SortableElement, arrayMove, SortableHandle} from 'react-sortable-hoc';
import _ from "lodash";

const DragHandle = SortableHandle(() => <i className="fa fa-bars handler"></i>);
const SortableItem = SortableElement(({value,SortableItemClassName}) =>
    <li className={`list-group-item list-group-item-action ${SortableItemClassName}`}><DragHandle /> {value}</li>
);

const SortableList = SortableContainer(({items,SortableItemClassName}) => {
    return (
        <ul className="list-group">
            {items.map((value, index) => (
                <SortableItem key={`item-${index}`} index={index} value={value.name} SortableItemClassName={SortableItemClassName} />
            ))}
        </ul>
    );
});
class SortableComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: _.orderBy(this.props.files, ['order'],['asc'])
        };
    }
    onSortEnd = ({oldIndex, newIndex}) => {
        this.setState({
            items: arrayMove(this.state.items, oldIndex, newIndex),
        });
        this.props.reorder(this.state);
    };
    render() {
        return <SortableList items={this.state.items || []} onSortEnd={this.onSortEnd} SortableItemClassName={this.props.SortableItemClassName} />;
    }
}

export default SortableComponent


// WEBPACK FOOTER //
// ./resources/assets/js/components/forms/models/SortableList.jsx